<template>
  <div class="presupuesto-interno-datos-renglones">
    <b-card header="Ordenes de Trabajo">
      <b-table 
          small 
          responsive="sm" 
          :busy="tableBusy"
          :class="{ 'registro-ordenes': true,
            'cotizacion-interna': tieneRecargoServicioPropio,
            'cotizacion-final': consultaCotizacionFinal,
            // 'presupuesto-consolidado': incluirAdicionales? true : false,
            'vista-produccion': vistaSimplificadaOrdenes? true : false
          }"
          :items="ordenesDatos" 
          :fields="renglonesFields">
          <!-- :fields="vistaOrdenesDatos" -->
        <template v-slot:cell(presupuestoAdicional)="data">
          {{ data.item.presupuestoAdicional != 0 ? String(data.item.presupuestoAdicional).padStart(3, '0')  : '' }}
        </template>
        <template v-slot:cell(tieneImagenes)="data">
          <template v-if="data.item.tieneImagenes">
            <i class="fa fa-image"></i>
          </template>
        </template>            
        <template v-slot:cell(costoInterno)="data">
          {{ data.item.costoInterno | moneda(data.item.moneda) }}
        </template>
        <template v-slot:cell(costoReal)="data">
          {{ data.item.costoReal | moneda }}
        </template>
        <template v-slot:cell(cotizacionInterna)="data">
          {{ data.item.cotizacionInterna | moneda(presupuestoDatos.moneda) }}
        </template>
        <template v-slot:cell(cotizacion)="data">
          {{ data.item.cotizacion | moneda(presupuestoDatos.moneda) }}
        </template>
        <template v-slot:cell(cotizacionFinal)="data">
          {{ data.item.cotizacionFinal | moneda(presupuestoDatos.moneda) }}
        </template>
        <template v-slot:cell(pjeRentabilidad)="data">
          <template v-if="data.item.pjeRentabilidad != 0">
            {{ data.item.pjeRentabilidad | porcentaje }}
          </template>
          <template v-if="data.item.pjeRentabilidad == 0">
            {{ '--.--%' }}
          </template>
        </template>
        <template v-slot:cell(pjeRentabilidadReal)="data">
          <template v-if="data.item.pjeRentabilidadReal != 0">
            {{ data.item.pjeRentabilidadReal | porcentaje }}
          </template>
          <template v-if="data.item.pjeRentabilidadReal == 0">
            {{ '--.--%' }}
          </template>
        </template>
        <template v-slot:cell(feeAgencia)="data">
          {{ data.item.feeAgencia | porcentaje }}
        </template>
        <template v-slot:cell(importeFeeAgencia)="data">
          {{ data.item.importeFeeAgencia | moneda(presupuestoDatos.moneda) }}
        </template>
        <template v-slot:cell(pjeImpuestos)="data">
          {{ data.item.pjeImpuestos | numero(2, true) }}
        </template>
        <template v-slot:cell(importeNeto)="data">
          {{ data.item.importeNeto | moneda(presupuestoDatos.moneda) }}
        </template>
        <template v-slot:cell(importeImpuestos)="data">
          {{ data.item.importeImpuestos | moneda(presupuestoDatos.moneda) }}
        </template>
        <template v-slot:cell(importeTotal)="data">
          {{ data.item.importeTotal | moneda(presupuestoDatos.moneda) }}
        </template>
        <template v-slot:cell(alternativas)="data">
          <span v-if="data.item.tieneAlternativas" class="col-alternativas">*</span>
        </template>

        <template v-slot:cell(opciones)="data">
          <b-dropdown variant="link" toggle-class="text-decoration-none" no-caret >
            <template slot="button-content">
              <i class="fa fa-ellipsis-v"></i>
            </template>
            <b-dropdown-item
                @click.stop="consultarImagenes(data.item)">
              <i class="fa fa-image"></i>Consultar Imágenes de la Orden</b-dropdown-item>
            <b-dropdown-item 
                v-if="!presupuestoCancelado & opcionAsignarUsuarios"
                @click.stop="asignarUsuarioOrden(data.item)">
              <i class="fa fa-user"></i>Asignar Usuarios</b-dropdown-item>
              <b-dropdown-item
                v-if="data.item.tieneAlternativas"
                @click.stop="consultarAlternativas(data.item)">
              <i class="fa fa-list"></i>Consultar Alternativas</b-dropdown-item>
          </b-dropdown>
        </template>

        <template v-slot:cell(detailShowing)="row">
          <b-btn class="detailShowing" 
              size="sm" 
              v-if= 'row.item.descripcion != ""'
              @click.stop="row.toggleDetails">
            {{ ( row.detailsShowing) ? '-' : '+' }}
          </b-btn>            
        </template>

        <template v-slot:row-details="row">
          <b-row>
            <b-col xl="12">
              {{ row.item.descripcion }}
            </b-col>
          </b-row>
        </template>
        <div slot="table-busy" class="text-center">
          <b-spinner class="table-spinner" label="Spinning" />
        </div>              
      </b-table>

      <b-row>
        <b-col>
          <small><span class="col-alternativas">*</span> Orden con alternativas </small>  
        </b-col> 
      </b-row>
      <b-row v-if="presupuestoDatos.autorizado">
        <b-col>
          <small>Autorizado para registrar margenes inferiores al minimo ({{ presupuestoDatos.usuarioAutorizacion }} - {{ presupuestoDatos.fechaAutorizacion | fecha }}) </small>
        </b-col> 
      </b-row>
    </b-card>

    <b-modal ref="ordenTrabajoUsuariosModal"
        title="Asignación de Usuarios"
        header-bg-variant= "light" 
        hide-footer
        lazy
        modal-class="modalABM">
      <app-orden-trabajo-usuarios
        :ordenTrabajoId="ordenTrabajoId"
        @close="closeAsignacionUsuariosOrden">
      </app-orden-trabajo-usuarios>  
    </b-modal>

    <b-modal ref="ordenTrabajoImagenesModal"
        hide-header
        hide-footer
        lazy
        modal-class="modalABM modalOrdenTrabajo">
      <app-orden-trabajo-imagenes
        :ordenTrabajoId="ordenTrabajoId"
        :readonly="Boolean(true)"
        @close="closeImagenes">
      </app-orden-trabajo-imagenes>  
    </b-modal>

    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>
  </div>
</template>

<script>
import OrdenTrabajoUsuarios from '../ordenestrabajos/UsuariosSeleccion';
import OrdenTrabajoImagenes from '../ordenestrabajos/Imagenes';
import Mensaje from  '../shared/msjModal.vue';
import { msjModal } from '../../mixins/modalDialogs';
import moment from 'moment';
import { createHelpers } from 'vuex-map-fields';

const { mapFields } = createHelpers({
  getterType: 'presupuestoInternoDatos/getField',
  mutationType: 'presupuestoInternoDatos/updateField',
});

export default {
  name: 'PresupuestoInternoData',
  components: {
    appOrdenTrabajoUsuarios: OrdenTrabajoUsuarios,
    appOrdenTrabajoImagenes: OrdenTrabajoImagenes,
    appMensaje: Mensaje
  },
  mixins: [
    msjModal
  ],
  props: {
    opcionAsignarUsuarios: {
      type: Boolean,
      default: false
    },
    incluirAdicionales: {
      type: Boolean,
      default: false
    },
    vistaSimplificadaOrdenes: {
      type: Boolean,
      default: false
    },
  },
  data: () => {
    return {
      tableBusy: false,

      labelCols: 2,
      ordenTrabajoId: 0,
    }
  },
  created() {
  },  
  computed: {
    ...mapFields([
      'presupuestoDatos',
      'ordenesDatos',
      'vistaOrdenesDatos',
    ]),
    presupuestoCancelado() {
      if (this.presupuestoDatos.cancelacionMotivoId) {
        if (this.presupuestoDatos.cancelacionMotivoId != 0) {
          return true;
        }
      }
      return false;
    },
    tieneRecargoServicioPropio() {
      if (this.presupuestoDatos) {
        if (this.presupuestoDatos.pjeRecargoServicioPropio) {
          return this.presupuestoDatos.pjeRecargoServicioPropio != 0;
        }
      }
      return false;
    },
    consultaCotizacionFinal() {
      if (this.presupuestoDatos) {
        if (this.presupuestoDatos.clienteId) {
          return this.presupuestoDatos.clienteId == 58;
        }
      }
      return false;
    },
    renglonesFields() {
      let fields = [
        { 
            key: 'tieneImagenes',
            label: '',
            class: 'text-center'
        },
        {
          key: 'detailShowing',
          label: '',
          class: 'text-center'
        },
        {
          key: 'rubroTrabajo',
          label: 'Rubro',
          sortable: true
        },
        {
          key: 'titulo',
          sortable: true
        },
        { 
          key: 'cantidad', 
          class: "text-right" },
        { 
          key: 'costoInterno', 
          label: 'Costo Interno',
          class: "text-right" 
        }
      ]
      if (!this.vistaSimplificadaOrdenes) {
        fields.push({ 
          key: 'pjeRentabilidad', 
          class: "text-right", 
          label: '% Rent.Estimada' 
        }); 
      }

      fields.push({ 
        key: 'costoReal', 
        label: 'Costo Real',
        class: "text-right" 
      });

      if (!this.vistaSimplificadaOrdenes) {
        fields.push({ 
          key: 'pjeRentabilidadReal', 
          class: "text-right", 
          label: '% Rent.Real',
        })

        if (this.tieneRecargoServicioPropio) {
          fields.push({ 
            key: 'cotizacionInterna', 
            class: "text-right", 
            label: 'Cotización Interna'
          });
        }

        fields.push({ 
          key: 'cotizacion', 
          class: "text-right", 
          label: 'Cotización'
        });

        if (this.consultaCotizacionFinal) {
          fields.push({ 
            key: 'cotizacionFinal', 
            class: "text-right", 
            label: 'Cotiz. Final'
          });
        }
        
        fields.push({
          key: 'alternativas', 
          class: "text-right", 
          label: ''
        });

        fields.push({ 
          key: 'opciones',
          label: '',
          class: 'text-center'
        });
      }

      return fields;
    },
  },
  methods: {
    asignarUsuarioOrden(item) {
      this.ordenTrabajoId = item.id;
      this.$refs.ordenTrabajoUsuariosModal.show();
    },
    closeAsignacionUsuariosOrden() {
      this.$refs.ordenTrabajoUsuariosModal.hide();
    },
    consultarImagenes(item) {
      this.ordenTrabajoId = item.id;
      this.$refs.ordenTrabajoImagenesModal.show()
    },
    closeImagenes() {
      this.$refs.ordenTrabajoImagenesModal.hide()
    },
    consultarAlternativas(item) {
      this.$emit('consultarAlternativas', item.id);
    }
  }
}
</script>

<style>
  /* Renglones del PI */
  .presupuesto-interno-datos-renglones .registro-ordenes table td {
    vertical-align: middle;
    border: none;
  }


  /* Renglones (s/cotizacion interna + s/cotizacion final) */

  /* Imagenes */
  .presupuesto-interno-datos-renglones .registro-ordenes table td[aria-colindex="1"] {
    width: 20px;
  }
  /* Detail showing */
  .presupuesto-interno-datos-renglones .registro-ordenes table td[aria-colindex="2"] {
    width: 20px;
  }
  /* Rubro */
  .presupuesto-interno-datos-renglones .registro-ordenes table td[aria-colindex="3"] {
    width: 15%;
  }
  /* Titulo */
  .presupuesto-interno-datos-renglones .registro-ordenes table td[aria-colindex="4"] {
    width: calc(27% - 80px);
  }
  /* Cantidad */
  .presupuesto-interno-datos-renglones .registro-ordenes table td[aria-colindex="5"] {
    width: 8%;
  }
  /* Costo Interno */
  .presupuesto-interno-datos-renglones .registro-ordenes table td[aria-colindex="6"] {
    width: 10%;
  }
  /* Pje Rentabilidad */
  .presupuesto-interno-datos-renglones .registro-ordenes table td[aria-colindex="7"] {
    width: 10%;
  }
  /* Costo Real */
  .presupuesto-interno-datos-renglones .registro-ordenes table td[aria-colindex="8"] {
    width: 10%;
  }
  /* Pje Rentabilidad Real */
  .presupuesto-interno-datos-renglones .registro-ordenes table td[aria-colindex="9"] {
    width: 10%;
  }
  /* Cotizacion */
  .presupuesto-interno-datos-renglones .registro-ordenes table td[aria-colindex="10"] {
    width: 10%;
  }
  /* Alternativas */
  .presupuesto-interno-datos-renglones .registro-ordenes table td[aria-colindex="11"] {
    width: 15px;
  }
  /* Opciones */
  .presupuesto-interno-datos-renglones .registro-ordenes table td[aria-colindex="12"] {
    width: 25px;
  }

  /* Renglones c/cotizacion interna (s/cotizacion final) */
  /* Rubro */
  .presupuesto-interno-datos-renglones .registro-ordenes.cotizacion-interna table td[aria-colindex="3"] {
    width: 10%;
  }
  /* Titulo */
  .presupuesto-interno-datos-renglones .registro-ordenes.cotizacion-interna table td[aria-colindex="4"] {
    width: calc(22% - 80px);
  }
  /* Cotizacion Interna */
  .presupuesto-interno-datos-renglones .registro-ordenes.cotizacion-interna table td[aria-colindex="10"] {
    width: 10%;
  }
  /* Cotizacion */
  .presupuesto-interno-datos-renglones .registro-ordenes.cotizacion-interna table td[aria-colindex="11"] {
    width: 10%;
  }
  /* Alternativas */
  .presupuesto-interno-datos-renglones .registro-ordenes.cotizacion-interna table td[aria-colindex="12"] {
    width: 15px;
  }
  /* Opciones */
  .presupuesto-interno-datos-renglones .registro-ordenes.cotizacion-interna table td[aria-colindex="13"] {
    width: 25px;
  }

  /* Renglones c/cotizacion final (s/cotizacion interna) */
  /* Rubro */
  .presupuesto-interno-datos-renglones .registro-ordenes.cotizacion-final table td[aria-colindex="3"] {
    width: 10%;
  }
  /* Titulo */
  .presupuesto-interno-datos-renglones .registro-ordenes.cotizacion-final table td[aria-colindex="4"] {
    width: calc(22% - 80px);
  }
  /* Cotizacion Final */
  .presupuesto-interno-datos-renglones .registro-ordenes.cotizacion-final table td[aria-colindex="11"] {
    width: 10%;
  }
  /* Alternativas */
  .presupuesto-interno-datos-renglones .registro-ordenes.cotizacion-final table td[aria-colindex="12"] {
    width: 15px;
  }
  /* Opciones */
  .presupuesto-interno-datos-renglones .registro-ordenes.cotizacion-final table td[aria-colindex="13"] {
    width: 25px;
  }

  /* Renglones c/cotizacion final y c/cotizacion interna */
  /* Rubro */
  .presupuesto-interno-datos-renglones .registro-ordenes.cotizacion-interna.cotizacion-final table td[aria-colindex="3"] {
    width: 10%;
  }
  /* Titulo */
  .presupuesto-interno-datos-renglones .registro-ordenes.cotizacion-interna.cotizacion-final table td[aria-colindex="4"] {
    width: calc(16% - 80px);
  }
  /* Cotizacion Interna */
  .presupuesto-interno-datos-renglones .registro-ordenes.cotizacion-interna.cotizacion-final table td[aria-colindex="10"] {
    width: 8%;
  }
  /* Cotizacion */
  .presupuesto-interno-datos-renglones .registro-ordenes.cotizacion-interna.cotizacion-final table td[aria-colindex="11"] {
    width: 8%;
  }
  /* Cotizacion Final */
  .presupuesto-interno-datos-renglones .registro-ordenes.cotizacion-interna.cotizacion-final table td[aria-colindex="12"] {
    width: 8%;
  }
  /* Alternativas */
  .presupuesto-interno-datos-renglones .registro-ordenes.cotizacion-interna.cotizacion-final table td[aria-colindex="13"] {
    width: 15px;
  }
  /* Opciones */
  .presupuesto-interno-datos-renglones .registro-ordenes.cotizacion-interna.cotizacion-final table td[aria-colindex="14"] {
    width: 25px;
  }


  /* Vista Simplificada (Producción) */
  /* Tiene imagenes */
  .presupuesto-interno-datos-renglones .registro-ordenes.vista-produccion table td[aria-colindex="1"] {
    width: 20px;
  }
  /* Detail showing */
  .presupuesto-interno-datos-renglones .registro-ordenes.vista-produccion table td[aria-colindex="2"] {
    width: 20px;
  }
  /* Rubro */
  .presupuesto-interno-datos-renglones .registro-ordenes.vista-produccion table td[aria-colindex="3"] {
    width: calc(30% - 20px); 
  }
  /* Titulo */
  .presupuesto-interno-datos-renglones .registro-ordenes.vista-produccion table td[aria-colindex="4"] {
    width: calc(36% - 20px);
  }
  /* Cantidad */
  .presupuesto-interno-datos-renglones .registro-ordenes.vista-produccion table td[aria-colindex="5"] {
    width: 10%;
  }
  /* Costo Interno */
  .presupuesto-interno-datos-renglones .registro-ordenes.vista-produccion table td[aria-colindex="6"] {
    width: 12%;
  }
  /* Costo Real */
  .presupuesto-interno-datos-renglones .registro-ordenes.vista-produccion table td[aria-colindex="7"] {
    width: 12%;
  }

  .presupuesto-interno-datos-renglones .registro-ordenes table td > i.fa-image {
    color: gray;
  }

  .presupuesto-interno-datos-renglones .registro-ordenes table tr.table-danger,
  .presupuesto-interno-datos-renglones .registro-ordenes table tr.table-danger td {
    background-color: transparent;
    color: var(--danger);
  }  
</style>